import Vue from 'vue'
import Router from 'vue-router'
const _import = require('./_import_' + process.env.NODE_ENV);
//判断页
const enter=_import('enter/enter');
//pc
const judgeIndex=_import('pc/judgeIndex');
const training=_import('pc/training');
const result=_import('pc/result');
const about=_import('pc/about');
const question=_import('pc/question');
const join=_import('pc/join');
//移动
const mJudgeIndex=_import('mobile/judgeIndex');
const mTraining=_import('mobile/training');
const mResult=_import('mobile/result');
const mAbout=_import('mobile/about');
const mQuestion=_import('mobile/question');
const mJoin=_import('mobile/join');
Vue.use(Router);
const routes = [
  //入口
  {
    path: '/',
    name: 'enter',
    meta:{},
    component: enter,
  },
  //pc-首页
  {
    path: '/judgeIndex',
    name: 'judgeIndex',
    meta:{},
    component: judgeIndex,
  },
  //pc-核心训练
  {
    path: '/training',
    name: 'training',
    meta:{},
    component: training,
  },
  //pc-成果分享
  {
    path: '/result',
    name: 'result',
    meta:{},
    component: result,
  },
  //pc-关于STEALTH
  {
    path: '/about',
    name: 'about',
    meta:{},
    component: about,
  },
  //pc-答疑解惑
  {
    path: '/question',
    name: 'question',
    meta:{},
    component: question,
  },
  //pc-加入我们
  {
    path: '/join',
    name: 'join',
    meta:{},
    component: join,
  },
  //手机端-首页
  {
    path: '/mJudgeIndex',
    name: 'mJudgeIndex',
    meta:{},
    component: mJudgeIndex,
  },
  //手机端-核心训练
  {
    path: '/mTraining',
    name: 'mTraining',
    meta:{},
    component: mTraining,
  },
  //手机端-成果分享
  {
    path: '/mResult',
    name: 'mResult',
    meta:{},
    component:mResult ,
  },
  //手机端-关于STEALTH
  {
    path: '/mAbout',
    name: 'mAbout',
    meta:{},
    component: mAbout,
  },
  //手机端-答疑解惑
  {
    path: '/mQuestion',
    name: 'mQuestion',
    meta:{},
    component: mQuestion,
  },
  //手机端-加入我们
  {
    path: '/mJoin',
    name: 'mJoin',
    meta:{},
    component: mJoin,
  },
]

const routeObj = new Router({
  routes:routes
})

export default routeObj;




// WEBPACK FOOTER //
// ./src/router/index.js